import { render, staticRenderFns } from "./menu-ingredient-chart.vue?vue&type=template&id=0e7511b6&"
import script from "./menu-ingredient-chart.vue?vue&type=script&lang=js&"
export * from "./menu-ingredient-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports